var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBuilding(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 39,
    viewBox: "0 0 40 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.1355 4.02548H7.41999C6.81869 4.02548 6.24201 4.26005 5.81682 4.67757C5.39164 5.0951 5.15277 5.66138 5.15277 6.25185V35.5307H24.4028V6.25185C24.4028 5.66138 24.1639 5.0951 23.7387 4.67757C23.3135 4.26005 22.7369 4.02548 22.1355 4.02548ZM22.2639 33.4304H19.0555V30.2799H10.5V33.4304H7.29166V6.25185C7.29166 6.2353 7.29498 6.21892 7.30143 6.20363C7.30788 6.18834 7.31733 6.17445 7.32925 6.16274C7.34116 6.15104 7.35531 6.14176 7.37088 6.13543C7.38645 6.12909 7.40314 6.12583 7.41999 6.12583H22.1355C22.1524 6.12583 22.1691 6.12909 22.1847 6.13543C22.2002 6.14176 22.2144 6.15104 22.2263 6.16274C22.2382 6.17445 22.2477 6.18834 22.2541 6.20363C22.2606 6.21892 22.2639 6.2353 22.2639 6.25185V33.4304Z",
    fill: "#235789"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.43054 9.2764H11.5694V11.3767H9.43054V9.2764Z",
    fill: "#235789"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7083 9.2764H15.8472V11.3767H13.7083V9.2764Z",
    fill: "#235789"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9861 9.2764H20.125V11.3767H17.9861V9.2764Z",
    fill: "#235789"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.43054 14.5273H11.5694V16.6276H9.43054V14.5273Z",
    fill: "#235789"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7083 14.5273H15.8472V16.6276H13.7083V14.5273Z",
    fill: "#235789"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9861 14.5273H20.125V16.6276H17.9861V14.5273Z",
    fill: "#235789"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.43054 19.7781H11.5694V21.8785H9.43054V19.7781Z",
    fill: "#235789"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7083 19.7781H15.8472V21.8785H13.7083V19.7781Z",
    fill: "#235789"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9861 19.7781H20.125V21.8785H17.9861V19.7781Z",
    fill: "#235789"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M9.43054 25.029H11.5694V27.1294H9.43054V25.029Z",
    fill: "#235789"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7083 25.029H15.8472V27.1294H13.7083V25.029Z",
    fill: "#235789"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9861 25.029H20.125V27.1294H17.9861V25.029Z",
    fill: "#235789"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4722 14.5273H27.6111V16.6276H25.4722V14.5273Z",
    fill: "#235789"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M29.75 14.5273H31.8889V16.6276H29.75V14.5273Z",
    fill: "#235789"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4722 19.7781H27.6111V21.8785H25.4722V19.7781Z",
    fill: "#235789"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M29.75 19.7781H31.8889V21.8785H29.75V19.7781Z",
    fill: "#235789"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4722 25.029H27.6111V27.1294H25.4722V25.029Z",
    fill: "#235789"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M29.75 25.029H31.8889V27.1294H29.75V25.029Z",
    fill: "#235789"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0278 14.9789V33.4305H25.4722V35.5308H36.1667V14.3908C35.4852 14.6839 34.7652 14.8819 34.0278 14.9789Z",
    fill: "#235789"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9583 12.427C35.9115 12.427 38.3055 10.0761 38.3055 7.17608C38.3055 4.2761 35.9115 1.9252 32.9583 1.9252C30.0051 1.9252 27.6111 4.2761 27.6111 7.17608C27.6111 10.0761 30.0051 12.427 32.9583 12.427Z",
    fill: "#235789"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilding);
export default __webpack_public_path__ + "static/media/building.82c161d66547457db3c3ea88442c6175.svg";
export { ForwardRef as ReactComponent };